import React from 'react';
import InputForm from '../../../InputT';
//import "../../Assets/Styles/StyleForm.css";
import Params from '../../../../Types/ParamsPicklist';
import { Box, Button, Tooltip } from '@mui/material';
import { SwipeUp } from '@mui/icons-material';
import { useAuthHeader, useAuthUser } from '../../../../Services/Auth/sessionAuth';
import Utilisateur from '../../../../Models/Utilisateur';
import SearchInput from '../../../SearchInput';
import { ColumnsType } from 'antd/es/table';
import File from '../../../File';
import DataTypeTable from '../../../../Types/DataTypeTable';
import SearchModal from '../../../SearchModal';


let searchUser:Params={CodeAgence:'',Table: "UTILIS",Colonne1:"CODUTI",Colonne2:"NOMUTI",Colagence:'001',Choix:22} 


let searchTypAdr:Params={CodeAgence:'',Table: "UTILIS",Colonne1:"CODUTI",Colonne2:"NOMUTI",Colagence:'001',Choix:22} 



//Initialisation des parametres de recherche
let searchTitre :Params={CodeAgence:'',Table: "TITRES",Colonne1:"CDTITR",Colonne2:"LIBELL1",Colagence:'101',Choix:22}
let searchSituationFamiliale :Params={CodeAgence:"SITFAM",Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:"RUBRIQ",Choix:22}
let searchProspect :Params={CodeAgence:'',Table: "DEMARC",Colonne1:"CODDMR",Colonne2:"LIBELL",Colagence:'101',Choix:22}
let searchClassRisque:Params={CodeAgence:'',Table: "CLARIS",Colonne1:"CLARIS",Colonne2:"LIBELLFR",Colagence:'101',Choix:22}
let searchPays :Params={CodeAgence:'',Table: "CDPAYS",Colonne1:"CDPAYS",Colonne2:"LIBELL",Colagence:'101',Choix:22}
let searchActivite :Params={CodeAgence:'',Table: "TABNAE",Colonne1:"CODNAE",Colonne2:"LIBELL",Colagence:'101',Choix:22}
let searchUniteInstitutionnel :Params={CodeAgence:'',Table: "TABNUI",Colonne1:"CODNUI",Colonne2:"LIBELL",Colagence:'101',Choix:22} 
let searchRegimeMatrimonial :Params={CodeAgence:"REGMAT",Table: "LIB",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:"RUBRIQ",Choix:22}
//
let searchNiveauInstruction :Params={CodeAgence:'',Table: "INSTRU",Colonne1:"CODINS",Colonne2:"LIBELL",Colagence:'101',Choix:22} 
let searchEthnie :Params={CodeAgence:'',Table: "ETHNIE",Colonne1:"CODETH",Colonne2:"LIBELL",Colagence:'101',Choix:22} 
let searchCateGo :Params={CodeAgence:'',Table: "CATEGO",Colonne1:"CATEGO",Colonne2:"LIBELLFR",Colagence:'101',Choix:22} 
let searchZoneGeo:Params={CodeAgence:'',Table: "RESIDE",Colonne1:"CDRESI",Colonne2:"LIBELLFR",Colagence:'101',Choix:22}
let searchCpt:Params={CodeAgence:'',Table: "AGENCE",Colonne1:"plc2",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchGroup:Params={CodeAgence:'',Table: "GROUPUSER",Colonne1:"CODGROUP",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchGes:Params={CodeAgence:'',Table: "GESTIONNAIRE",Colonne1:"CODGES",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchService:Params={CodeAgence:'',Table: "SERVICE",Colonne1:"CODSERV",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchIndice:Params={CodeAgence:'',Table: "CLIENT",Colonne1:"NUMCLI",Colonne2:"NOMCLI",Colagence:'101',Choix:22}
let searchCompte:Params={CodeAgence:'',Table: "CCOMPTES",Colonne1:"NUMCPT",Colonne2:"NOMCPT",Colagence:'101',Choix:22}
let searchStatus:Params={CodeAgence:'',Table: "Status",Colonne1:"CODLIB",Colonne2:"LIBELL",Colagence:'101',Choix:22}
let searchGroupUtilis:Params={CodeAgence:'',Table: "GROUPUSER",Colonne1:"CODGROUP",Colonne2:"LIBELLE",Colagence:'101',Choix:22}
let searchGarantie:Params={CodeAgence:'',Table: "GARANTIE",Colonne1:"",Colonne2:"",Colagence:'101',Choix:3}
let searchTypeGrantie:Params={CodeAgence:'',Table: "TYPEGARANTIE",Colonne1:"codgar",Colonne2:"LIBELL",Colagence:'101',Choix:22}
let searchGarantieForm:Params={CodeAgence:'',Table: "GARANTIE",Colonne1:"codgar",Colonne2:"DESIGNATION",Colagence:'101',Choix:22}


  
function Tab1(props:{form?: any}){
  // USER SESSION
  const auth = useAuthUser()
  const user : Utilisateur = JSON.parse(JSON.stringify(auth()))


  // USER TOKEN
  const authHeader = useAuthHeader()
  
  return(
    <div className='tabItem'>
      <div >
        <Box fontStyle="inherit" className = 'border border-left' width={"85%"} position={"absolute"} sx={{p:1}}>
           {/* <legend> Détail opération litigieuse </legend>  */}
          <Box display={"flex"} fontStyle="inherit"  >
              
            <Box fontStyle="inherit"  >
              <InputForm  width={9} icon={<SwipeUp color='disabled' fontSize='small'/>} label='Compte' name='NODUCP' type={'text'}/>
              <InputForm  width={9} icon={<SwipeUp color='disabled' fontSize='small'/>} label='Nom Client' name='REMETT' type={'text'}/>
              <InputForm  width={9} icon={<SwipeUp color='disabled' fontSize='small'/>} label='Code opération' name='CDLBEC' type={'text'}/>
              <InputForm  width={9} icon={<SwipeUp color='disabled' fontSize='small'/>} label='CNI Remettant' name='cniremet' type={'text'}/>
            </Box>
            <Box fontStyle="inherit" >
              <InputForm label='Sens opération' width={9} icon={<SwipeUp color='disabled' fontSize='small'/>}   name='sensOpe'  type='TEXT' error='mobile' />
              <InputForm label='Utilisateur' width={9} icon={<SwipeUp color='disabled' fontSize='small'/>}   name='UTISAI'  type='TEXT' error='mobile' />
              <InputForm  width={9} icon={<SwipeUp color='disabled' fontSize='small'/>} label='Autorisation' name='AUTORI' type={'text'}/>
              <InputForm  width={9} icon={<SwipeUp color='disabled' fontSize='small'/>} label='Solde après ope' name='soldeApreOpe' type={'text'}/>
            </Box>
            
            <Box fontStyle="inherit" >
              
              <InputForm label='Disponible' width={9} icon={<SwipeUp color='disabled' fontSize='small'/>}   name='DISPON'  type='text' error='mobile' />
              <InputForm label='Montant bloqué' width={9} icon={<SwipeUp color='disabled' fontSize='small'/>}   name='BLOQUE'  type='TEXT' error='mobile' />
              <InputForm width={9} icon={<SwipeUp color='disabled' fontSize='small'/>} label='Solde veille' name='SOLDEV' type={'text'}/>
              <InputForm width={9} icon={<SwipeUp color='disabled' fontSize='small'/>} label='Montant Opérat°' name='MONTAN' type={'text'}/>
            </Box>
          </Box>
          <Box display={"flex"} fontStyle="inherit" >
            <Box fontStyle="inherit" width={"100%"}>
              <InputForm label='Libellé opération' icon={<SwipeUp color='disabled' fontSize='small'/>}   name='LIBELL'  type='TextArea' error='mobile' />
            </Box><hr />
            <Box fontStyle="inherit" width={"100%"} >
              <InputForm  icon={<SwipeUp color='disabled' fontSize='small'/>} label='Motif' name='LIBOPE' type={'TextArea'}/>
            </Box>
          </Box>
        </Box>
      </div>
    </div>
  )
}

export default Tab1;  
